import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./routes/Home";
import Channel from "./routes/Channel";
import Invite from './routes/Invite';
import Login from './routes/Login';
import ProtectedRoute from './components/auth/ProtectedRoute';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        } />
        <Route path="/channel/:id" element={
          <ProtectedRoute>
            <Channel />
          </ProtectedRoute>
        } />
        <Route path="/invite/:id/:from" element={
          <ProtectedRoute>
            <Invite />
          </ProtectedRoute>
        } />

        {/* No other routes match */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
